const formStyles = `
.hbspt-form {
  padding-bottom: 30px;
}

.hs-form {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  align-items: stretch;
  border-bottom: 1px solid rgb(220, 220, 220);
  position: relative;
}

.hs-email {
  width: 100%;
  margin: auto;
}

.hs-email > label {
  display: none;
}

.hs-error-msgs {
  position: absolute;
  font-size: 12px;
  color: #c13f3f;
  bottom: 0;
  transform: translateY(30px);
  }

.hs-input {
  width: 100%;
  color: rgb(139, 139, 139);
  font-size: 14px;
  line-height: 17px;
  padding: 0;
  background: none !important;
  border: none;
  min-height: 45px;
}

.actions {
  margin:  0;
  padding: 0;
}

.hs-button {
  font-weight: var(--weight-medium);
  font-size: 16px !important;
  line-height: 19px !important;
  text-align: center;
  color: rgb(92, 123, 235);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background: url('/static/svg/arrow-blue-right.svg') right center
    no-repeat !important;
  border: none;
  min-width: 82px;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: 45px;
  cursor: pointer;
  margin-right: 15px;
  padding-right: 20px;
}
`;

export default formStyles;
